import type { ApiError } from "@/services/api";

import { isValidObject } from "@/utilities/object";

export const isAPIError = (
  error: Error | ApiError | unknown
): error is ApiError => isValidObject(error) && "response" in error;
